import { createSelector } from '@reduxjs/toolkit';

const selectAllEventsSlice = (state) => state.allEvents;

export const selectAllEventsFilters = createSelector([selectAllEventsSlice], (s) => s.filters);
export const selectAllEventsFilterOptions = createSelector([selectAllEventsSlice], (s) => s.filterOptions);
export const selectAllEventsFilterOptionsLoading = createSelector([selectAllEventsSlice], (s) => s.filterOptionsLoading);
export const selectAllEventsTotalItems = createSelector([selectAllEventsSlice], (s) => s.totalItems);
export const selectAllEventsCurrentPage = createSelector([selectAllEventsSlice], (s) => s.currentPage);
export const selectAllEventsPageSize = createSelector([selectAllEventsSlice], (s) => s.pageSize);
export const selectAllEventsSearchLoading = createSelector([selectAllEventsSlice], (s) => s.searchLoading);
export const selectAllEventsTableId = createSelector([selectAllEventsSlice], (s) => s.tableId);
export const selectAllEventsTableConfigName = createSelector([selectAllEventsSlice], (s) => s.tableConfigName);
